module.exports = __webpack_public_path__ + "static/media/IJCL.23692918.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/books/IJCL.jpg
// module id = 1755
// module chunks = 1